'use strict';
import React from 'react/addons';

import BemMixin from '../BemMixin';
import Icon from '../common/Icon';

var PureRenderMixin = React.addons.PureRenderMixin;


var DatePickerPaginationArrow = React.createClass({
  mixins: [BemMixin, PureRenderMixin],

  render() {
    var {disabled, direction, onTrigger, ...props} = this.props;
    var modifiers = {[direction]: true};
    var states = {disabled};

    var elementOpts = {
      element: "PaginationArrow",
      modifiers,
      states
    };

    var iconOpts = {
      element: "PaginationArrowIcon",
      modifiers,
      states
    };

    return (
      <div className={this.cx(elementOpts)} {...props} onClick={onTrigger}>
        <div className={this.cx(iconOpts)}><Icon glyph="arrow" size="small" variant={direction === 'previous' ? 'left' : 'right'} /></div>
      </div>
    );
  }
});

export default DatePickerPaginationArrow;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/datepicker/DatePickerPaginationArrow.jsx
 **/